export enum MessageStatus {
  accepted = 'accepted',
  queued = 'queued',
  sending = 'sending',
  sent = 'sent',
  failed = 'failed',
  delivered = 'delivered',
  undelivered = 'undelivered',
  read = 'read',
  unsubscribed = 'unsubscribed',
}
